
import {  
  faSort,
  faEye,
  faSync,
  faBan,
  faTrash,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faUser,
  faTachometerAlt,
  faHeart,
  faList,
  faTasks,
  faBook,
  faHdd,
  faLock,
  faSignInAlt,
  faSignOutAlt,
  faWrench,
  faThList,
  faUserPlus,
  faAsterisk,
  faFlag,
  faBell,
  faHome,
  faRoad,
  faCloud,
  faTimesCircle,
  faSearch,
  faEuroSign,
  faCalendar } from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';

export const loadIcons = () => {
  library.add(
    faSort,
    faEye,
    faSync,
    faBan,
    faTrash,
    faArrowLeft,
    faSave,
    faPlus,
    faPencilAlt,
    faUser,
    faTachometerAlt,
    faHeart,
    faList,
    faTasks,
    faBook,
    faHdd,
    faLock,
    faSignInAlt,
    faSignOutAlt,
    faWrench,
    faThList,
    faUserPlus,
    faAsterisk,
    faFlag,
    faBell,
    faHome,
    faRoad,
    faCloud,
    faTimesCircle,
    faSearch,
    faEuroSign,
    faCalendar
  );
};
